import { getTreatPoints } from '@libs/api-proxy-client';

export type TreatPointsBody = {
    sku: string;
    price: number;
    quantity: number;
};

export type TreatPointsResponse = {
    treatPoints: number;
    loyaltyId: string;
};

export const fetchTreatPoints = async ({ sku, price, quantity }: TreatPointsBody) => {
    return await getTreatPoints<TreatPointsResponse>({
        sku,
        price,
        quantity,
    });
};
